// /mnt/mantenimientos/frontend/src/components/ThemeToggle.jsx
import React from 'react';
import useDarkMode from '../hooks/useDarkMode';

export default function ThemeToggle({ compact = false }) {
  const { theme, toggle } = useDarkMode();
  return (
    <button
      onClick={toggle}
      className="button"
      title={theme === 'dark' ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
      style={compact ? { padding: '6px 10px' } : undefined}
    >
      {theme === 'dark' ? '🌞 Claro' : '🌙 Oscuro'}
    </button>
  );
}
